import React from "react";
import LabelValue from "../../../shared/custom/labelValue/LabelValue";
import {useLanguageForShared} from "../../../shared/utils/languages/useLanguageForShared";
import {useDateCustom} from "../../../shared/custom_use/useDateCustom";
import {isArray} from "../../../shared/utils/arrayUtils";
import {PrescriptionFlowRow} from "./PrescriptionFlowRow";
import {
    prescriptionTypeLabel
} from "../../../app/pages/products/selectProduct/component/templates/data/prescriptionTypeData";

type PrescriptionType = "LOX" | "TOC" | "POC" | "COX";

type Props = {
    data: any;
    types: PrescriptionType[];
};

export function TemplateReadPrescription({data, types}: Props) {
    const {t} = useLanguageForShared();
    const {data: dateFormatter} = useDateCustom();

    const pathologyValue =
        isArray(data?.pathology) && data.pathology.length > 0
            ? data.pathology.map((p: string) => t(`pathology.${p}`)).join(", ")
            : "-";

    return (
        <div className="template-sg prescription-25 row row-gap-4">

            {/* ================= ROW 1 — PATHOLOGIES ================= */}
            {data?.pathology?.length > 0 && (
                <div className="col-12">
                    <LabelValue
                        label={t("common.pathologies")}
                        value={pathologyValue}
                    />
                    {data?.otherPathologies && (
                        <LabelValue
                            label={t("common.otherPathologies")}
                            value={data.otherPathologies}
                        />
                    )}
                </div>
            )}


            {/* ================= ROW 3 — FLOW / LEVEL (CICLO) ================= */}
            <div className="col-12">
                {types.map((type) => (
                    <PrescriptionFlowRow
                        key={type}
                        data={data}
                        type={type}
                    />
                ))}
            </div>

            {/* ================= ROW 4 — INTERFACES ================= */}
            <div className="col-12">
                <p className="title-paragraph">{t("sg.otherInfo")}</p>
                <div className="col-12">

                    <LabelValue
                        label={t("prescription.template.cannulaNasal.label")}
                        value={data?.cannulaNasal ? t("common.yes") : t("common.no")}
                    />

                    {data?.cannulaNasal && (
                        <>
                            <LabelValue
                                label={t("prescription.template.cannulaType.label")}
                                value={data?.cannulaType || "-"}
                            />
                            <LabelValue
                                label={t("prescription.template.cannulaModel.label")}
                                value={data?.cannulaModel || "-"}
                            />
                        </>
                    )}
                </div>
                <div className="col-12">

                    <LabelValue
                        label={t("prescription.template.mask.label")}
                        value={data?.mask ? t("common.yes") : t("common.no")}
                    />

                    {data?.mask && (
                        <>
                            <LabelValue
                                label={t("prescription.template.maskModel.label")}
                                value={data?.maskModel || "-"}
                            />
                            <LabelValue
                                label={t("prescription.template.maskSize.label")}
                                value={data?.maskSize || "-"}
                            />
                        </>
                    )}
                </div>
            </div>

            {/* ================= ROW 5 — NOTE ================= */}
            <div className="col-12">
                <LabelValue
                    label={t("prescription.template.note.label")}
                    value={data?.note || "-"}
                />
            </div>

            {/* ================= ROW 6 — DATES & TYPE ================= */}
            <div className="col-12">
                <LabelValue
                    label={t("prescription.template.validUntil")}
                    value={
                        data?.validUntil
                            ? dateFormatter.dateFormatGGmmmYY(data.validUntil)
                            : "-"
                    }
                />

                <LabelValue
                    label={t("prescription.template.dateNextCheck")}
                    value={
                        data?.dateNextCheck
                            ? dateFormatter.dateFormatGGmmmYY(data.dateNextCheck)
                            : "-"
                    }
                />
                <LabelValue
                    label={t("prescription.template.prescriptionType.title")}
                    value={
                        data?.prescriptionType ? t(prescriptionTypeLabel[data?.prescriptionType]) : "-"
                    }
                />
            </div>
        </div>
    );
}